import { SET } from '../';
import { TreatmentService } from '@/services';

export default {
	namespaced: true,
	state: {
		categories: []
	},
	mutations: {
		SET
	},
	actions: {
		async getTreatments({ commit, state }) {
			if (state.categories.length) return state.categories;

			const categories = await TreatmentService.GetTreatments();
			if (categories) {
				commit('SET', { key: 'categories', value: categories });
			}

			return categories;
		}
	},
	getters: {
		treatments: state => state.categories.slice()
	}
};
